<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable">
    <base-status-diagram
      :value="value.product"
      :selected="value.status"
      no-icons
      disabled
    />
    <!--
    :errors="filterErrors('statuses')"
    :selected="selectedStatus || selectedArrow"
    @status="selectStatus"
    @arrow="selectArrow"
    @none="selectNone"
    -->
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import BaseStatusDiagram from "@/modules/core/product/protected/BaseStatusDiagram";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    BaseStatusDiagram
  }
};
</script>
